module.exports = __webpack_public_path__ + "img/icon_accepted.4349e328.svg";